import { todayKeyIst } from "../utils/formatters";

/**
 * Subscription "valid until" date picker with quick-preset chips. Used by the
 * super-admin firm onboarding and seats/subscription drawers to set a trial,
 * a paid expiry, or to extend / reduce an existing period.
 *
 * Props:
 *   - isTrial: tweaks the label/default copy.
 *   - value:   ISO (YYYY-MM-DD) period_end.
 *   - onChange(iso): called when the date or a preset chip changes it.
 *   - presets: [{ label, iso }] quick options (computed by the parent so they
 *              can be relative to today or to the current period_end).
 *   - error:   optional validation message.
 *   - label:   optional override label.
 */
export default function ExpiryField({ isTrial, value, onChange, presets = [], error, label }) {
  return (
    <div className="field">
      <label className="field-label">{label || (isTrial ? "Trial valid until" : "Valid until")}</label>
      <input
        className="input"
        type="date"
        min={todayKeyIst()}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {presets.length > 0 && (
        <div className="row gap-sm" style={{ marginTop: 6, flexWrap: "wrap" }}>
          {presets.map((p) => (
            <button
              type="button"
              key={p.label}
              className={`chip ${value === p.iso ? "active" : ""}`}
              onClick={() => onChange(p.iso)}
            >
              {p.label}
            </button>
          ))}
        </div>
      )}
      {error && <div className="field-error">{error}</div>}
    </div>
  );
}
